import PropTypes from "prop-types";
import React, { Component } from "react";

import {
    Controls,
    Inventory
} from "./components/index";
import { di } from "../../../../bottle";
import { Container } from "../../../../components/index";


// exports
export class Customize extends Component {

    static propTypes = {
        canCustomize: PropTypes.bool.isRequired,
        onPressReset: PropTypes.func.isRequired,
        partCategoryTap$: PropTypes.func.isRequired,
        onBikeChanged: PropTypes.func.isRequired
    };

    static defaultProps = {
        canCustomize: true,
        onPressReset: () => undefined,
        partCategoryTap$: () => undefined,
        onBikeChanged: () => undefined
    };

    constructor(props) {

        // call base constructor
        super(props);

        // set state
        this.state = {
            showInventory: false,
            inventoryCatalog: null
        };

        // bind methods
        this._showInventory = this._showInventory.bind(this);
        this._hideInventory = this._hideInventory.bind(this);
        this._onPartCategoryTap = this._onPartCategoryTap.bind(this);
    }

    componentWillMount() {
        this.partCategoryTapSubscription = this.props.partCategoryTap$.subscribe(this._onPartCategoryTap)
    }

    componentWillUnmount() {
        if (this.partCategoryTapSubscription) {
            this.partCategoryTapSubscription.unsubscribe()
        }
    }

    componentWillReceiveProps(props) {
        if (props.canCustomize === false) {
            this.setState({
                showInventory: false,
                inventoryCatalog: null
            })
        }
    }

    _onPartCategoryTap(tapCategory) {
        if (tapCategory) {
            let tapInventory = di.garage.group(tapCategory);
            if (tapInventory.categories.length > 0) {
                this.setState({
                    inventoryCatalog: tapInventory,
                    showInventory: true
                })
            }
        }
    }

    render() {

        // resolve inputs
        const { showInventory, inventoryCatalog } = this.state;
        const { garage } = di;

        // conditionally render inventory
        const inventory =
            <Inventory
                show={showInventory}
                catalog={inventoryCatalog}
                onBikeChanged={this.props.onBikeChanged}
                onClose={this._hideInventory} />;

        const changeAccessories = () => {
            this._showInventory(garage.accessories)
        };
        const changeCosmetics = () => {
            this._showInventory(garage.cosmetics)
        };

        // render view
        return (
            <Container flex touchless style={styles.container}>
                <Controls
                    canCustomize={this.props.canCustomize}
                    onPressBuild={changeAccessories}
                    onPressColor={changeCosmetics}
                    onPressReset={this.props.onPressReset}
                />
                {inventory} 
            </Container>
        );
    }

    _showInventory(catalog) {
        this.setState({
            showInventory: true,
            inventoryCatalog: catalog
        });
    }

    _hideInventory() {
        this.setState({
            showInventory: false,
            inventoryCatalog: null
        });
    }
}


const styles = {
    container: {
        position: "absolute",
        width: "100%",
        height: "100%",
        bottom: 0,
        right: 0,
        zIndex: 2
    }
};



// WEBPACK FOOTER //
// ./src/pages/Customization/components/Customize/index.js